module.exports = __webpack_public_path__ + "static/media/logo.e17c6555.png";